var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid grid-cols-6 gap-4" }, [
    _c("div", { staticClass: "col-span-1 relative hidden md:block" }, [
      _c(
        "div",
        {
          staticClass:
            "absolute inset-0 overflow-scroll scrollbar-hidden thumbnails",
        },
        [
          _vm._t("thumbnails", null, {
            activeImage: _vm.sharedState.activeImage,
            setActiveImage: _vm.setActiveImage,
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-span-6 md:col-span-5 relative ratio-16:11" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-span-6 md:hidden relative h-24" }, [
      _c(
        "div",
        {
          staticClass:
            "absolute inset-0 overflow-scroll scrollbar-hidden thumbnails-mobile flex items-start",
        },
        [
          _vm._t("thumbnails", null, {
            activeImage: _vm.sharedState.activeImage,
            setActiveImage: _vm.setActiveImage,
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }